export let safeModeLabel = "Q3GSvb";
export let recoveryModeLabel = "CWfUZc";
export let configJsonActiveLabel = "AFoaId";
export let configJsonActiveDetails = "S5u0ec";
export default {safeModeLabel,recoveryModeLabel,configJsonActiveLabel,configJsonActiveDetails};